import React from "react"
import { inject, observer } from "mobx-react"
import { Button, Input, Popconfirm, Select, Spin, Table, Tooltip } from "antd"
import moment from "moment"
import commissions from "@services/commissions"
import { alertPopup } from "@utils/popup"
import { toLiteralMonth } from "../utils"
import MathExpr, { op } from "../CreateNewCommission/MathExpr"

@inject(({ authStore, mentorCommissionStore }) => ({ authStore, mentorCommissionStore }))
@observer
class MentorCommissionList extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loadingMentorCommissions: false,
            loadingDelete: null,
            loadingEdit: null,
            showReports: null,
            mentorCommissions: [],

            editData: {
                year: '',
                month: '',
                payment_type: '',
                status: '',
                amount: '',
                percent: '',
                months_to_charge: ''
            }
        }
    }

    componentDidMount() {
        this.props.mentorCommissionStore.resetList()
        this.getMentorCommissions()
    }

    // getMentorCommissions some-how. per client or per page of clients
    // getMentorCommissions = () => {

    //     const { client_id, agentInfo } = this.props

    //     this.setState({ loadingMentorCommissions: true }, () => {
    //         commissions.getMentorCommissionsByAgentClient({ agent_id: agentInfo.id, mentor_id: agentInfo.mentor_id, client_id })
    //         .then((res) => {
    //             this.setState({ mentorCommissions: res.data })
    //         })
    //         .catch((error) => {
    //             console.log('error', error)
    //         })
    //         .finally(() => {
    //             this.setState({ loadingMentorCommissions: false })
    //         })
    //     })
    // }

    getMentorCommissions = () => {

        const { client_id, agentInfo } = this.props
        this.props.mentorCommissionStore.getMentorCommissions({
            agent_id: agentInfo.id,
            mentor_id: agentInfo.mentor_id,
            client_id
        })

    }

    deleteCommission = (commission_id) => {

        this.setState({ loadingDelete: commission_id }, () => {
            commissions.deleteMentorCommission({ commission_id })
            .then((res) => {
                this.getMentorCommissions()
                alertPopup({ type: 'success', title: 'העמלה נמחקה', body: '' })
            })
            .catch((error) => {
                console.log('error', error)
                alertPopup({ type: 'error', title: 'אירעה שגיאה', body: '' })
            })
            .finally(() => {
                this.setState({ loadingDelete: null })
            })
        })

    }

    setEdit = (record) => {

        this.setState({
            editId: record.id,
            editData: {
                status: record.status,
                payment_type: record.payment_type,
                months_to_charge: record.months_to_charge,
                month: record.month,
                year: record.year,
                amount: record.amount,
                percent: record.percent
            }
        })
    }

    saveCommissionChanges = () => {

        const {
            editId,
            editData: {
                status,
                payment_type,
                months_to_charge,
                month,
                year,
                amount,
                percent
            }
        } = this.state

        const payload = {
            id: editId,
            status,
            payment_type,
            months_to_charge,
            month,
            year,
            amount,
            percent
        }

        this.setState({ loadingEdit: editId }, () => {
            commissions.editMentorCommission(payload)
            .then((res) => {
                this.getMentorCommissions()
                alertPopup({ type: 'success', title: 'העדכון בוצע בהצלחה', body: '' })
            })
            .catch((error) => {
                console.log('saveCommissionChanges', error)
                alertPopup({ type: 'error', title: 'אירעה שגיאה', body: '' })
            })
            .finally(() => {
                this.setState({ loadingEdit: null, editId: null })
            })
        })



    }

    onInput = ({ target }) => {
        let { id, value } = target
        let field = id.split('_')[1]

        if (field == 'amount') {
            // sanitize. numbers only:

            // value = value.replace('')
        } // else if (field == '')

        this.setState({ editData: { ...this.state.editData, [field]: value } })

    }

    // statuses = {
    //     ACTIVE: { text: 'פעיל', color: 'green' },
    //     CANCELED: { text: 'מבוטל', color: 'red' },
    //     ON_HOLD: { text: 'מושהה', color: '' }

    // }

    // balance = {
    //     CREDIT: { text: 'זכות', color: 'green' },
    //     DEBT: { text: 'חיוב', color: 'red' }
    // }

    statuses = (status) => {
        let obj = {
            ACTIVE: { text: 'פעיל', color: 'green' },
            CANCELED: { text: 'מבוטל', color: 'red' },
            ON_HOLD: { text: 'מושהה', color: '' }
        }

        return obj[status] || { text: status, color: '' }
    }

    balances = (balance) => {
        let obj = {
            CREDIT: { text: 'זכות', color: 'green' },
            DEBT: { text: 'חיוב', color: 'red' }
        }

        return obj[balance] || { text: balance, color: '' }
    }

    columns = [
        {
            title: 'נוצר בתאריך',
            align: 'right',
            key: 'aa',
            render: (record) => <span>{moment(record.created_at).format('DD/MM/YYYY hh:mm')}</span>
        },
        {
            title: 'עודכן בתאריך',
            align: 'right',
            key: 'bb',
            render: (record) => <span>{moment(record.updated_at).format('DD/MM/YYYY hh:mm')}</span>
        },
        {
            title: 'שם המינוי',
            align: 'right',
            key: 'cc',
            render: (record) => <span>{record.subscription_name}</span>
        },
        {
            title: 'מחיר',
            align: 'right',
            key: 'dd',
            render: (record) => {
                if (this.state.editId !== record.id) {
                    return (
                        <span>{record.amount}</span>
                    )
                } else {
                    return (
                        <Input
                            value={this.state.editData.amount}
                            defaultValue={record.amount}
                            onChange={(e) => this.onInput(e)}
                            id="mentorCommissions_amount"
                        />
                    )
                }
            }
        },
        {
            title: 'זכות/חיוב',
            align: 'right',
            key: 'ee',
            render: (record) => (
                <span
                    style={ { color: this.balances(record.balance).color } }
                >
                    {this.balances(record.balance).text}
                </span>
            )
        },
        {
            title: 'סטטוס',
            align: 'right',
            key: 'ff',
            render: (record) => {
                if (this.state.editId !== record.id) {
                    return (
                        <span
                            style={ { color: this.statuses(record.status).color } }
                        >
                            {this.statuses(record.status).text}
                        </span>
                    )
                } else {
                    return (
                        <Select
                                onChange={(value) => this.setState({ editData: { ...this.state.editData, status: value } })}
                                defaultValue={record.status}
                                style={{
                                    width: 100,
                                    paddingRight: '0px'
                            }}>
                                <Select.Option value="ACTIVE">{"פעיל"}</Select.Option>
                                <Select.Option value="CANCELED">{"בוטל"}</Select.Option>
                                {/* {record.balance === 'CREDIT' && <Select.Option value="ON_HOLD">{"מושהה"}</Select.Option>}
                                {record.balance === 'DEBT' && <Select.Option value="CHARGED">{"שולם"}</Select.Option>} */}
                        </Select>
                    )
                }
            }
        },
        {
            title: 'חודשים',
            align: 'right',
            key: 'gg',
            render: (record) => {
                let months =
                record.balance === 'CREDIT' ?
                    (record.payment_type === 'ONE_TIME' ? 1 : 12) :
                    record.months_to_charge

                if (record.balance  === 'CREDIT' || this.state.loadingEdit !== record.id) {
                    return (
                        <span>{months}</span>
                    )
                } else {
                    return (
                        <Select
                            value={this.state.editData.months_to_charge}
                            defaultValue={record.months_to_charge}
                            onChange={(months_to_charge) => this.setState({ editData: { ...this.state.editData, months_to_charge } })}
                        >
                            {new Array(12).fill(null).map((_, num) => {
                                return <Select.Option value={num} style={{ paddingInline: '0' }} key={num.toString()}>{num}</Select.Option>
                            })}

                        </Select>
                    )
                }
            }
        },
        {
            title: 'חיוב/זיכוי מחושב',
            align: 'right',
            key: 'ii',
            render: (record) => {
                let months =
                record.balance === 'CREDIT' ?
                    (record.payment_type === 'ONE_TIME' ? 1 : 12) :
                    record.months_to_charge

                return (
                    <Tooltip
                        title={
                            <MathExpr
                                tokens={[
                                    { value: record.amount },
                                    op('×'),
                                    { value: record.percent },
                                    op('×'),
                                    { value: months }
                                ]}
                            />
                        }
                    >
                        <span>{(months * record.amount * record.percent).toFixed(2)}</span>
                    </Tooltip>
                )

            }
        },
        {
            title: 'שנה',
            key: 'year',
            align: 'right',
            render: (record) => {
                if (this.state.editId !== record.id) {
                    return <span>{record.year + 2000}</span>
                } else {
                    return (
                        <Select
                            value={this.state.editData.year}
                            defaultValue={record.year}
                            onChange={(year) => this.setState({ editData: { ...this.state.editData, year } })}
                            dropdownClassName="custom-dropdown"
                            dropdownStyle={{
                                maxHeight: '300px',  // Prevent the dropdown from becoming too large
                                overflowY: 'auto',   // Enable scrolling if necessary
                                width: '100%',       // Ensures the dropdown width matches the parent width
                                minWidth: '200px',   // Avoids the dropdown being too narrow
                                zIndex: 9999         // Keeps the dropdown on top of other elements
                            }}
                            getPopupContainer={(triggerNode) => triggerNode.parentNode}  // Ensures dropdown is inside the correct container
                        >
                            {Array.from({ length: 15 }, (_, i) => 17 + i).map((num) => (
                                <Select.Option value={num} key={num.toString()}>{num + 2000}</Select.Option>
                            ))}
                        </Select>
                    )
                }
            }
        },
        {
            title: 'חודש',
            key: 'month',
            align: 'right',
            render: (record) => {
                if (this.state.editId !== record.id) {
                    return <span>{toLiteralMonth(record.month)}</span>
                } else {
                    return (
                        <Select
                            value={this.state.editData.month}
                            defaultValue={record.month}
                            onChange={(month) => this.setState({ editData: { ...this.state.editData, month } })}
                            dropdownClassName="custom-dropdown"
                            dropdownStyle={{
                                maxHeight: '300px',   // Control the height of the dropdown
                                overflowY: 'auto',    // Add scroll if needed
                                width: '100%',        // Ensure the dropdown fits the width of the parent container
                                minWidth: '200px',    // Prevent clipping when options are many
                                zIndex: 9999          // Ensure the dropdown is on top of other elements
                            }}
                            getPopupContainer={(triggerNode) => triggerNode.parentNode}  // Render dropdown in the correct place
                        >
                            {new Array(13).fill(null).map((_, num) => (
                                <Select.Option value={num} key={num.toString()}>{num}</Select.Option>
                            ))}
                        </Select>
                    )
                }
            }
        }

    ]

    moneyColumns = [
        // {
        //     title: '',
        //     align: 'right',
        //     key: 'reports',
        //     render: (record) => {

        //         // [{"date": “2024-03", "percent": "0.03", "payment_type": "ONE_TIME"}]

        //         console.log('reportrrstrst', record.reports)

        //         if (record.reports) {
        //             let reports = JSON.parse(record.reports)

        //             // this.state.showReports

        //             if (this.state.showReports == record.id) {
        //                 // modal:
        //                 return (
        //                     <div style={{ position: 'relative' }}>
        //                         <div style={{ ...style.modal }} >
        //                             <span
        //                                 style={{ ...style.closeBtn, alignSelf: 'start' }}
        //                                 onClick={() => this.setState({ showReports: null })}
        //                             >
        //                                 {"+"}
        //                             </span>
        //                             {reports.map((rep) => {
        //                                 return (
        //                                     <div>
        //                                         <div>{rep.date}</div>
        //                                         <div>{rep.percent}</div>
        //                                         {/* <div>{rep.amount}</div> */}
        //                                     </div>
        //                                 )
        //                             })}
        //                         </div>
        //                     </div>
        //                 )
        //             } else {
        //                 return (
        //                     <Button
        //                         onClick={() => this.setState({ showReports: record.id })}>
        //                         {"דוחות"}
        //                     </Button>
        //                 )
        //             }
        //         } else return (
        //             <Button disabled={true}>{"דוחות"}</Button>
        //         )

        //     }
        // },
        {
            title: '',
            align: 'right',
            key: 'jj',
            render: (record) => {
                if (this.state.editId == record.id) {
                    return (
                        <div>
                            <Button
                                onClick={() => this.setState({ editId: null })}
                            >
                                {"ביטול"}
                            </Button>
                            <Button
                                onClick={this.saveCommissionChanges}
                            >
                                {"שמירה"}
                            </Button>
                            {this.state.loadingEdit == record.id ? <Spin /> : ''}
                        </div>
                    )

                } else {
                    return (
                        <Button
                            onClick={() => this.setEdit(record)}
                            >
                            {"עריכה"}
                        </Button>
                    )
                }
            }
        },
        {
            title: '',
            align: 'right',
            key: 'kk',
            render: (record) => {
                return (
                    <Popconfirm
                        title={"האם למחוק?"}
                        okText={'כן'}
                        cancelText={'לא'}
                        onConfirm={() => this.deleteCommission(record.id)}
                    >
                        <Button
                            style={{ color: 'red' }}
                            >
                            {"מחיקה"}
                        </Button>
                        {this.state.loadingDelete == record.id ? <Spin /> : ''}
                    </Popconfirm>
                )
            }
        }
    ]

    adminColumns = []

    render () {
        const { authStore: { roles }, agentInfo: { mentor } } = this.props
        const { mentorCommissions, loadingMentorCommissions } = this.props.mentorCommissionStore

        // const { mentorCommissions, loadingMentorCommissions } = this.state

        let columns = []
        if (roles.includes('admin')) columns = [...this.columns, ...this.moneyColumns, ...this.adminColumns]
        else if (roles.includes('money')) columns = [...this.columns, ...this.moneyColumns]
        else columns = this.columns

        return (
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                <span style={{ margin: '20px 0' }}>{`שם המנטור: ${mentor}`}</span>
                {loadingMentorCommissions ?
                    <Spin /> :
                    <Table
                        columns={columns}
                        dataSource={mentorCommissions}
                    />
                }
            </div>
        )
    }
}

const style = {
    closeBtn: {
        rotate: '45deg',
        cursor: 'pointer',
        fontSize: '26px',
        margin: '0 10px 0 0'
    },
    modal: {
        display: 'flex',
        flexDirection: 'column',
        minWidth: '250px',
        minHeight: '200px',
        background: 'white',
        borderRadius: '10px',
        border: 'solid #d9d9d9 1px',
        boxShadow: '0 0 16px 3px #d9d9d9',
        position: 'absolute',
        left: 'calc(50% - 125px)',
        top: '-100px',
        zIndex: '1',
        overflowY: 'scrol'
    }
}

export default MentorCommissionList
